import React from 'react'
import { withRouter } from 'react-router'

import globalState from '../../helpers/globalState'
import { buildQuery, parseQuery } from '../../helpers/filterSort'

import Styles from '../../styles/components/headerFilterSort.module.scss'
const { container, list, item, itemActive } = Styles

class FilterSort extends React.PureComponent {
  constructor(props) {
    super(props)

    this.listenHistory = this.listenHistory.bind(this)
    this.queriesToGlobalStateMap = this.queriesToGlobalState()
  }

  renderOptions(options, current, stateKey, propKey) {
    const qArgs = {}
    for (let key in this.queriesToGlobalStateMap) {
      qArgs[key] = this.props[key]
    }

    return options.map(option => {
      return (
        <li
          key={option.value}
          className={current === option.value ? itemActive : item}
          onClick={() => {
            const q = buildQuery(
              {
                ...qArgs,
                [propKey]: option.value,
              },
              true
            )

            if (option.value !== current) {
              window.___gatsbyNavigateTo(`${this.props.location.pathname}${q}`)

              globalState.setState({
                [stateKey]: option.value,
              })
            }
          }}
        >
          {option.label}
        </li>
      )
    })
  }

  componentDidMount() {
    this.setGlobalStateFromPath(this.props.location.search)
    this.unlistenHistory = this.props.history.listen(this.listenHistory)
  }

  listenHistory(location) {
    this.setGlobalStateFromPath(location.search)
  }

  componentWillUnmount() {
    this.unlistenHistory()
  }

  componentWillReceiveProps(nextProps) {
    this.setGlobalStateFromPath(nextProps.location.search)
  }

  setGlobalStateFromPath(getQuery) {
    const initial = {}
    for (let key in this.queriesToGlobalStateMap) {
      initial[key] = null
    }
    const newQuery = parseQuery(getQuery, initial)

    let changed = false
    const newState = {}
    for (let key in this.queriesToGlobalStateMap) {
      const globalKey = this.queriesToGlobalStateMap[key]

      if (globalState.state[globalKey] !== newQuery[key]) {
        changed = true
      }

      newState[globalKey] = newQuery[key]
    }

    if (changed) {
      globalState.setState(newState)
    }
  }

  renderContent() {
    return null
  }

  render() {
    const { inHeader = true } = this.props

    if (!inHeader) {
      return <div className={Styles.notInHeader}>{this.renderContent()}</div>
    } else {
      return this.renderContent()
    }
  }
}

export default FilterSort
export { parseQuery }



// WEBPACK FOOTER //
// ./src/components/header/filterSort.js